import api from './api';

const tutorialVideoService = {
  getPublicVideos: async () => {
    const response = await api.get('/tutorial-videos/public');
    return response.data;
  },

  getAllVideos: async () => {
    const response = await api.get('/tutorial-videos');
    return response.data;
  },

  createVideo: async (data) => {
    const response = await api.post('/tutorial-videos', data);
    return response.data;
  },

  updateVideo: async (id, data) => {
    const response = await api.put(`/tutorial-videos/${id}`, data);
    return response.data;
  },

  deleteVideo: async (id) => {
    const response = await api.delete(`/tutorial-videos/${id}`);
    return response.data;
  }
};

export default tutorialVideoService;
